/* eslint-disable */
import { useContext } from 'react'
import dayjs from 'dayjs'
import SearchedResultList from './SearchedResultList'
import { useLocation, useNavigate } from 'react-router-dom'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderLabel } from '../../utils/provider'

export default function ProvidersResult() {
  const { customerId } = useContext(OrgAppContext)
  const location = useLocation()
  const { providerResult } = location.state
  const navigation = useNavigate()
  const columns = [
    {
      field: 'id',
      headerName: getProviderLabel(customerId, 'id'),
      flex: 1,
      renderCell: (params: any) => (
        <div
          className='linkStyle'
          onClick={() => {
            navigation('/provider/providerInvestigation', { state: { searchID: params.value } })
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'firstAccessTime',
      headerName: 'First Access Time',
      flex: 1,
    },
    {
      field: 'lastAccessTime',
      headerName: 'Last Access Time',
      flex: 1,
    },
  ]
  return <SearchedResultList data={providerResult} columns={columns} />
}
